import { render, staticRenderFns } from "./AccountingSetting.vue?vue&type=template&id=49cccf64&"
import script from "./AccountingSetting.vue?vue&type=script&lang=ts&"
export * from "./AccountingSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports